import React, { useEffect, useState } from "react";

const CustomRatingNew = ({ max, value, handleInputChange, name, readonly }) => {
  const [selectedValue, setSelectedValue] = useState(null);

  useEffect(() => {
    setSelectedValue(+value);
  }, [value]);

  const getColorForRating = (rating) => {
    if (selectedValue >= 1 && rating <= selectedValue) {
      switch (rating) {
        case 1:
          return "#ff0000";
        case 2:
          return "#ff1919";
        case 3:
          return "#ff3232";
        case 4:
          return "#ff4c4c";
        case 5:
          return "#ff6666";
        case 6:
          return "#ff7f7f";
        case 7:
          return "#e5b000";
        case 8:
          return "#ffc400";
        case 9:
          return "#329932";
        default:
          return "#198c19";
      }
    } else {
      return "transparent";
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "stretch",
        width: "100%", // parent width (e.g., 200px container)
      }}
    >
      {Array(max)
        .fill()
        .map((id, val) => {
          let value = val + 1;
          return (
            <button
              key={value}
              style={{
                flex: 1,
                minWidth: 0,
                backgroundColor:
                  selectedValue >= value ? getColorForRating(value) : "transparent",
                border: "1px solid #ccc",
                borderRadius: "4px",
                margin: "2px",
                color: selectedValue >= value ? "white" : "black",
                cursor: readonly ? "default" : "pointer",
                fontSize: "0.7rem",
                padding: "2px 0",
              }}
              name={name}
              onClick={() => {
                if (!readonly) {
                  setSelectedValue(value);
                  handleInputChange({ target: { name, value } });
                }
              }}
              value={selectedValue}
            >
              {value}
            </button>
          );
        })}
    </div>
  );
};

export default CustomRatingNew;
